import axios, { AxiosResponse } from "axios";
import { store } from "../store/store";
import { list_hub_per_request_url, list_hub_url } from "../constants/urls";
import { defaultHeadersWithToken } from "../constants/constants";
import { ServerResponse_ } from "@/interfaces/Server";
import { HUB, HUB_ } from "@/interfaces/HUB";

export async function getHUBs(): Promise<
  AxiosResponse<ServerResponse_<HUB[]>>
> {
  const accessToken = store.getState().authentication.accessToken;
  try {
    const response: AxiosResponse<ServerResponse_<HUB[]>> = await axios({
      url: list_hub_url,
      headers: defaultHeadersWithToken(accessToken),
      method: "GET",
    });
    return response;
  } catch (error: any) {
    return error.response;
  }
}

export async function getRequestHUBs(
  requestId: string
): Promise<AxiosResponse<ServerResponse_<HUB_[]>>> {
  const accessToken = store.getState().authentication.accessToken;
  try {
    const response: AxiosResponse<ServerResponse_<HUB_[]>> = await axios({
      url: list_hub_per_request_url + requestId,
      headers: defaultHeadersWithToken(accessToken),
      method: "GET",
    });
    return response;
  } catch (error: any) {
    return error.response;
  }
}
